/*
 * De koopbalk onderin de productpagina.
 *
 * Het thema had er zelf een, maar die kwam pas tevoorschijn als het hele
 * productformulier boven het scherm uit was gescrold. Op een telefoon staat de
 * foto bovenaan en begint de informatie pas rond 470 pixels; de knop zelf staat
 * dan rond de duizend, ruim onder de vouw. Je opent een product en er is geen
 * enkele manier om iets te kopen zonder eerst te scrollen -- en de balk die dat
 * had moeten opvangen wachtte juist tot je nog verder was.
 *
 * Hier is de regel omgedraaid: de balk staat er zodra de echte knop niet in
 * beeld is. Dus meteen bij het openen, en hij verdwijnt zodra je bij de knop
 * zelf bent. Twee koopknoppen tegelijk in beeld is verwarrend; nul is erger.
 *
 * Over de voet blijft hij weg. Daar sta je te lezen wat de openingstijden zijn,
 * niet te twijfelen over een maat, en een balk die de links afdekt is dan
 * alleen maar in de weg.
 *
 * De taakverdeling: de waarnemer meldt dát er iets verandert, het rekenwerk
 * bepaalt wát er dan moet gebeuren. Die twee zijn met opzet gescheiden. Een
 * waarnemer geeft alleen door of iets de grens passeerde, en dat is niet te
 * controleren zonder de pagina echt te laten tekenen. Twee rechthoeken
 * vergelijken kan altijd, ook op het moment van laden, en levert hetzelfde op.
 * Een scrollluisteraar zou hetzelfde doen maar dan bij elke pixel; de waarnemer
 * meldt zich alleen als het antwoord verandert.
 *
 * Waarom een eigen element en niet de ingebouwde: die zit in theme.js, en dat
 * bestand is van het thema. Bij een update is elke wijziging daarin weg. De
 * opmaak van de balk staat in sections/main-product.liquid en dat is van ons,
 * dus daar is de elementnaam omgezet naar deze.
 */

(() => {
  class Koopbalk extends HTMLElement {
    connectedCallback() {
      // De echte knop staat in de productinformatie; die in deze balk is de
      // kopie. Zonder die afbakening zou de balk zichzelf meten.
      this.knop =
        document.querySelector('.product-info buy-buttons') ||
        document.querySelector('.product-info [type="submit"]');
      this.voet = document.querySelector('.shopify-section--footer');

      if (!this.knop) return;

      this.laatste = null;
      this.bijwerken = this.bijwerken.bind(this);

      this.kijker = new IntersectionObserver(this.bijwerken);
      this.kijker.observe(this.knop);
      if (this.voet) this.kijker.observe(this.voet);

      window.addEventListener('resize', this.bijwerken, { passive: true });

      // Niet wachten op de eerste melding: bij het laden staat de knop op een
      // telefoon al onder de vouw, en dan hoort de balk er meteen te zijn.
      this.bijwerken();
    }

    disconnectedCallback() {
      this.kijker?.disconnect();
      window.removeEventListener('resize', this.bijwerken);
    }

    /*
     * De knop telt pas als hij er helemaal staat.
     *
     * Eerst was de toets of hij het scherm raakte, en dat gaat mis op een laag
     * venster: op 1280 bij 720 begint de knop op 692 en is er dus 28 pixels van
     * te zien. Die telde mee, de balk ging weg, en je hield een streepje knop
     * over aan de onderrand. Hij hoort er dan juist te staan.
     */
    helemaalInBeeld(el) {
      if (!el) return false;
      const r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return false;
      return r.top >= 0 && r.bottom <= window.innerHeight;
    }

    /* Voor de voet is aanraken wel genoeg: zodra die in beeld komt hoort de
       balk weg te zijn, niet pas als de voet er helemaal staat. */
    raaktScherm(el) {
      if (!el) return false;
      const r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return false;
      return r.bottom > 0 && r.top < window.innerHeight;
    }

    bijwerken() {
      const tonen = !this.helemaalInBeeld(this.knop) && !this.raaktScherm(this.voet);
      if (tonen === this.laatste) return;

      this.laatste = tonen;
      this.classList.toggle('is-visible', tonen);
    }
  }

  if (!window.customElements.get('collett-koopbalk')) {
    window.customElements.define('collett-koopbalk', Koopbalk);
  }
})();
